import {
  SET_ADDITIONAL_PARAMS,
  SET_SUBSCRIPTION_FREQUENCY,
  SET_SUBSCRIPTION_TYPES,
} from "./actionTypes";

export const setAdditionalParams = (value) => ({
  type: SET_ADDITIONAL_PARAMS,
  payload: value,
});

export const setSubscriptionFrequency = (value) => ({
  type: SET_SUBSCRIPTION_FREQUENCY,
  payload: value,
});

export const setSubscriptionTypes = (value) => ({
  type: SET_SUBSCRIPTION_TYPES,
  payload: value,
});
